import { Directive, Input } from '@angular/core';

// Minimal no-op directives to satisfy Angular templates that use MDC list attributes.
// These do not provide MDC behavior; they only prevent template compilation errors.

@Directive({
  selector: '[mdcList]'
})
export class MdcListDirective {
  @Input() dense?: boolean | string;
  @Input() nonInteractive?: boolean | string;
}

@Directive({
    selector: '[mdcListItem]'
})
export class MdcListItemDirective {
  @Input() selected?: boolean | string;
  @Input() disabled?: boolean | string;
  @Input() value?: any;
}

@Directive({
  selector: '[mdcListItemGraphic]'
})
export class MdcListItemGraphicDirective {}

@Directive({
  selector: '[mdcListItemMeta]'
})
export class MdcListItemMetaDirective {}

@Directive({
  selector: '[mdcListDivider]'
})
export class MdcListDividerDirective {
  @Input() inset?: boolean | string;
}

@Directive({
  selector: '[mdcListGroup]'
})
export class MdcListGroupDirective {}

@Directive({
  selector: '[mdcListGroupSubHeader]'
})
export class MdcListGroupSubHeaderDirective {}
